// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1HANO","choiceBoxes":"toolbarselects_choiceBoxes__xw-p2","simpleField":"toolbarselects_simpleField__2i_pw"};